<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-9.col-10.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="getExchangeRateList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="5%")
                  span #
                th(width="10%")
                  span(:title="$t('ui.module')") {{ $t('ui.module') }}
                th(width="10%")
                  span(:title="$t('ui.currency')") {{ $t('ui.currency') }}
                th.text-right(width="10%")
                  span(:title="$t('ui.deposit_rate')") {{ $t("ui.deposit_rate") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.withdrawal_rate')") {{ $t("ui.withdrawal_rate") }}
                th.text-center(width="10%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th(width="10%")
                  span(:title="$t('ui.modified_by')") {{ $t("ui.modified_by") }}
                th.text-right(width="15%")
                  span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
            tbody.clusterize-content
              tr(v-if="rateList.length == 0")
                td(colspan="7").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in rateList")
                td.text-center
                  span(:title="index + 1") {{ index + 1 }}
                td
                  span(:title="item.module") {{ item.module }}
                td
                  span(:title="item.currency") {{ item.currency }}
                td.text-right
                  span(:title="item.base_rate") {{ item.base_rate }}
                td.text-right
                  span(:title="item.base_rate_w") {{ item.base_rate_w }}
                td.text-center(v-if="isEditAccess")
                  span
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                td
                  span(:title="item.modified_by") {{ item.modified_by }}
                td.text-right
                  span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.modified_date") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}

      editexchangerate(ref="editexchangerate" :item="editSelectedCurrency" @clicked="afterEdit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editexchangerate from "@/components/setup/editExchangeRateOp.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editexchangerate,
  },
  data: () => ({
    loading: false,
    rateList: [],
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedCurrency: null,
    searchModule: 'MEMBER',
    currency: 'USDT'
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_exchangerate");
    }
  },
  mounted: function() { },
  methods: {
    refresh() {
      this.getExchangeRateList();
    },
    onEdit(e) {
      this.editSelectedCurrency = e;
      this.$refs.editexchangerate.$refs.editExchangeRate.show();
    },
    afterEdit: function(item) {
      this.getExchangeRateList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_exchange_rate"), this.$t("message.success"), "success");
    },
    getExchangeRateList: function() {
      let url = config.exchangeRateOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        module: this.searchModule,
        // currency: this.currency 
      };

      if (this.search.trim() != '') {
        json.currency = this.search.trim();
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.rateList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>